import { Button, Typography } from '@breetometer/components';
import { StatusIcon } from 'BreetAssets';
import { type CURRENCYCODETYPE, CURRENCYCONFIG } from 'BreetHelpers';

import type { ITransactionMobileColumnRight } from '../TransactionsMobileColumn.helpers';

const MobileColumnRight = ({ amount, status, currency, onClick, children, value }: ITransactionMobileColumnRight) => (
	<Button
		variant='native'
		className='datatable_mobilecolumnright'
		onClick={onClick}
	>
		{children ?? (
			<>
				<Typography
					as='h6'
					className='color-neutral-50'
				>
					{value ?? `${CURRENCYCONFIG[currency as unknown as CURRENCYCODETYPE].symbol}${amount}`}
				</Typography>
				<StatusIcon status={status} />
			</>
		)}
	</Button>
);

export default MobileColumnRight;
